export const isRelease263Enabled = process.env.REACT_APP_SHOW_RELEASE_263 === 'true';

export const isGenesGtpHeatmapEnabled = process.env.REACT_APP_SHOW_GENES_GTP_HEATMAP === 'true';

export const RELEASE_263_TABLE_COLUMNS = ['GTP', 'disease_model', 'sex', 'gender'] as const;

export const RELEASE_263_FILTER_NAMES = ['GTP', 'tces', 'disease_model', 'sex'] as const;
